import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import SEO from '../../components/SEO';
import '../EmailChangeApproved/styles.css';

export default function CpAcknowledged() {
  const [searchParams] = useSearchParams();
  const encodedPayload = searchParams.get('p');
  const error = searchParams.get('error');

  // Decode payload if present (encoded redirect from backend); otherwise fall back to legacy query params
  let action, name, dashboard;
  if (encodedPayload) {
    try {
      const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
      const padding = base64.length % 4 ? '='.repeat(4 - (base64.length % 4)) : '';
      const json = atob(base64 + padding);
      const payload = JSON.parse(json);
      action = payload.action;
      name = payload.name;
      dashboard = payload.dashboard || '/member-selection';
    } catch (e) {
      action = null;
      name = '';
      dashboard = '/member-selection';
    }
  } else {
    action = searchParams.get('action');
    name = searchParams.get('name') || '';
    dashboard = searchParams.get('dashboard') || '/member-selection';
  }

  const errorMessages = {
    expired: 'This acknowledgement link has expired. Please log in to respond in the app.',
    invalid_or_expired: 'This link is invalid or has already been used.',
    invalid_params: 'This link appears to be malformed.',
    server_error: 'A server error occurred. Please try again or contact support.'
  };

  if (error) {
    return (
      <div className="email-change-page">
        <SEO title="Continuity Principal | EternaVaults" />
        <div className="email-change-container">
          <div className="email-change-card">
            <div className="success-icon" style={{ color: '#bfa97a' }}>
              <AlertCircle size={64} />
            </div>
            <h1>Link Error</h1>
            <p className="email-change-message">
              {errorMessages[error] || 'An error occurred processing this link.'}
            </p>
            <div className="email-change-actions">
              <Link to={dashboard} className="btn-primary">
                Go to Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (action === 'accept') {
    return (
      <div className="email-change-page">
        <SEO title="Role Accepted | EternaVaults" />
        <div className="email-change-container">
          <div className="email-change-card">
            <div className="success-icon">
              <CheckCircle size={64} />
            </div>
            <h1>Role Accepted</h1>
            <p className="email-change-message">
              {name
                ? `${name}, you have accepted the Continuity Principal role.`
                : 'You have accepted the Continuity Principal role.'}
            </p>
            <div className="email-display">
              <p style={{ color: '#bfa97a', fontSize: '0.95rem' }}>
                The family admin has been notified. Upon succession, you will inherit authority
                to manage and protect the family's digital legacy.
              </p>
            </div>
            <div className="email-change-actions">
              <Link to={dashboard} className="btn-primary">
                Go to Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Decline
  return (
    <div className="email-change-page">
      <SEO title="Nomination Declined | EternaVaults" />
      <div className="email-change-container">
        <div className="email-change-card">
          <div className="success-icon" style={{ color: '#bfa97a' }}>
            <XCircle size={64} />
          </div>
          <h1>Nomination Declined</h1>
          <p className="email-change-message">
            You have declined the Continuity Principal nomination.
          </p>
          <div className="email-display">
            <p style={{ color: '#bfa97a', fontSize: '0.95rem' }}>
              The family admin has been notified and may designate another person for this role.
            </p>
          </div>
          <div className="email-change-actions">
            <Link to={dashboard} className="btn-primary">
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
